export const messages = {
  a11yActionsColumn: 'Actions column',
  a11yRowActions: 'Row actions',
  a11ySortBy: 'Sorted by',
};
